var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavServiceRequestNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FFF6BA88-CE3D-4E53-90B7-9E503FB8761F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company-Portal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard1",
    transform: "translate(-18.000000, -332.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F8F8FA",
    x: 0,
    y: 0,
    width: 1680,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-CompanyAdmin"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#344A5C",
    x: 0,
    y: 0,
    width: 245,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-Off",
    transform: "translate(0.000000, 321.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NavServiceRequest",
    transform: "translate(18.000000, 332.000000)",
    fill: "#979598",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.61909787,4.60318857 C8.11914223,1.1190535 13.814669,1.13496279 17.298804,4.63500716 C20.2738418,7.62595416 20.7670298,12.3510141 18.4601824,15.882877 L18.4283638,15.9306049 L21.6579502,19.8761094 C21.6579502,19.8761094 21.6614856,19.8796448 21.6667887,19.8849479 L21.7056781,19.9238373 C22.1193197,20.4011161 22.1193197,21.101125 21.7215874,21.5465852 L21.6579502,21.6261316 L21.5784037,21.6897688 C21.101125,22.1034104 20.4011161,22.1034104 19.907928,21.6897688 C19.8761094,21.6738595 19.8442909,21.6420409 19.8442909,21.6420409 L15.9146956,18.4283638 L15.882877,18.4601824 C12.3510141,20.7670298 7.62595416,20.2738418 4.63500716,17.298804 C1.13496279,13.814669 1.1190535,8.11914223 4.60318857,4.61909787 Z M15.4851447,6.43275722 C12.9873858,3.93499829 8.91460686,3.93499829 6.41684793,6.43275722 C3.91908899,8.93051615 3.91908899,13.0032951 6.41684793,15.501054 C8.91460686,17.9988129 12.9873858,17.9988129 15.4851447,15.501054 C17.9829036,13.0032951 17.9829036,8.93051615 15.4851447,6.43275722 Z M11.0464521,6.51230368 C12.4623791,6.54412227 13.5283017,7.7691378 13.2101159,9.13733696 L13.162388,9.32824847 L13.3373902,9.43961352 C13.4169367,9.48734139 13.4646645,9.56688786 13.4805738,9.66234361 C13.5123924,9.74189007 13.5283017,9.82143654 13.5283017,9.91689229 C13.5283017,10.0441666 13.4964831,10.171441 13.432846,10.282806 C13.3373902,10.5373547 13.0828415,10.7123569 12.7964742,10.7123569 L12.7487464,10.7123569 L12.7328371,10.7759941 C12.6532906,11.2373636 12.4146512,11.6510052 12.0487375,11.9214632 L12.0010096,11.969191 L12.0010096,12.5896534 C12.0010096,12.5896534 13.8783061,13.2260251 14.7374079,13.655576 C14.8965009,13.7351225 15.0237752,13.8623969 15.119231,14.0055805 C14.960138,14.2124013 14.7851358,14.4192221 14.5942243,14.6101336 C12.5896534,16.6306138 9.31233918,16.6306138 7.29185902,14.5942243 C7.10094751,14.4033128 6.92594529,14.196492 6.76685236,13.9896712 C6.86230812,13.8464876 6.98958246,13.7192132 7.14867539,13.6396668 C8.00777718,13.2260251 9.88507371,12.5896534 9.88507371,12.5896534 L9.88507371,11.969191 L9.83734583,11.9214632 C9.4714321,11.6510052 9.23279271,11.2214543 9.15324625,10.7759941 L9.13733696,10.7123569 L9.08960908,10.7123569 C8.80324181,10.7123569 8.54869313,10.5373547 8.45323738,10.282806 C8.38960021,10.171441 8.35778162,10.0441666 8.35778162,9.91689229 C8.35778162,9.82143654 8.37369091,9.74189007 8.4055095,9.66234361 C8.42141879,9.56688786 8.48505596,9.48734139 8.54869313,9.43961352 L8.72369535,9.32824847 L8.67596747,9.13733696 C8.35778162,7.7691378 9.42370422,6.54412227 10.8396313,6.51230368 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavServiceRequestNormal);
export default __webpack_public_path__ + "static/media/NavServiceRequestNormal.c37feabb28b0f2b56685820972fb5960.svg";
export { ForwardRef as ReactComponent };